import { PolicyPodetailReq, PolicyPodetailResp } from 'app/bff/models/policy/policyPodetail';
import { AaOtpSendcodeReq, AaOtpSendcodeResp } from 'app/bff/models/aa/aaOtpSendcode';
import { AaOtpVerifyReq } from 'app/bff/models/aa/aaOtpVerify';
import { PolicyAmendTravelperiodReq } from 'app/bff/models/policy/policyAmendTravelperiod';
import { PaymentCreditAuthReq } from 'app/bff/models/payment/paymentCreditAuth';
import { ProcessStepCodesEnum } from 'app/features/Service/QueryPolicy/Modify/types';
import { FormValues as PolicyInfoFormValues } from 'app/features/Service/QueryPolicy/Modify/PolicyInfo/types';

// State type
export interface ModifyState {
  static: StaticState;
  process: ProcessState;
  modifyPolicyPeriodArgs?: PolicyAmendTravelperiodReq;
  transId?: string;
}

interface StaticState {
  detail?: PolicyPodetailResp['policyTravel'];
  paymentWSUUID?: string;
}

interface ProcessState {
  accessibleSteps: ProcessStepCodesEnum[];
  policyInfo: {
    data?: PolicyInfoFormValues;
  };
  confirmInfo: {
    otpAuth: {
      otp?: AaOtpSendcodeResp;
    };
  };
}
// ::: End

// Actions type constant
export const SERVICE_QUERY_POLICY_MODIFY__FETCH_POLICY_DETAIL = 'SERVICE_QUERY_POLICY_MODIFY__FETCH_POLICY_DETAIL';
export const SERVICE_QUERY_POLICY_MODIFY__FETCH_POLICY_DETAIL_DONE = 'SERVICE_QUERY_POLICY_MODIFY__FETCH_POLICY_DETAIL_DONE';
export const SERVICE_QUERY_POLICY_MODIFY__SET_ACCESSIBLE_STEP = 'SERVICE_QUERY_POLICY_MODIFY__SET_ACCESSIBLE_STEP';
export const SERVICE_QUERY_POLICY_MODIFY__SAVE_POLICY_INFO_PAGE_DATA = 'SERVICE_QUERY_POLICY_MODIFY__SAVE_POLICY_INFO_PAGE_DATA';
export const SERVICE_QUERY_POLICY_MODIFY__SEND_OTP = 'SERVICE_QUERY_POLICY_MODIFY__SEND_OTP';
export const SERVICE_QUERY_POLICY_MODIFY__SEND_OTP_DONE = 'SERVICE_QUERY_POLICY_MODIFY__SEND_OTP_DONE';
export const SERVICE_QUERY_POLICY_MODIFY__RESEND_OTP = 'SERVICE_QUERY_POLICY_MODIFY__RESEND_OTP';
export const SERVICE_QUERY_POLICY_MODIFY__RESEND_OTP_DONE = 'SERVICE_QUERY_POLICY_MODIFY__RESEND_OTP_DONE';
export const SERVICE_QUERY_POLICY_MODIFY__AUTH_OTP = 'SERVICE_QUERY_POLICY_MODIFY__AUTH_OTP';
export const SERVICE_QUERY_POLICY_MODIFY__EXECUTE_CREDIT_CARD_PAYMENT = 'SERVICE_QUERY_POLICY_MODIFY__EXECUTE_CREDIT_CARD_PAYMENT';
export const SERVICE_QUERY_POLICY_MODIFY__MODIFY_POLICY_PERIOD = 'SERVICE_QUERY_POLICY_MODIFY__MODIFY_POLICY_PERIOD';
export const SERVICE_QUERY_POLICY_MODIFY__UPDATE_CACHE = 'SERVICE_QUERY_POLICY_MODIFY__UPDATE_CACHE';
export const SERVICE_QUERY_POLICY_MODIFY__RESET_CACHE = 'SERVICE_QUERY_POLICY_MODIFY__RESET_CACHE';
export const SERVICE_QUERY_POLICY_MODIFY__SAVE_MODIFY_REQ = 'SERVICE_QUERY_POLICY_MODIFY__SAVE_MODIFY_REQ';
export const SERVICE_QUERY_POLICY_MODIFY__SAVE_TRANS_ID = 'SERVICE_QUERY_POLICY_MODIFY__SAVE_TRANS_ID';
// ::: End

// Action creators type
export interface FetchPolicyDetailAction {
  type: typeof SERVICE_QUERY_POLICY_MODIFY__FETCH_POLICY_DETAIL;
  payload: {
    args: PolicyPodetailReq;
  };
}

export interface FetchPolicyDetailDoneAction {
  type: typeof SERVICE_QUERY_POLICY_MODIFY__FETCH_POLICY_DETAIL_DONE;
  payload: {
    response: PolicyPodetailResp['policyTravel'];
  };
}

export interface SetAccessibleStepAction {
  type: typeof SERVICE_QUERY_POLICY_MODIFY__SET_ACCESSIBLE_STEP;
  payload: {
    step: ProcessStepCodesEnum;
  };
}

export interface SavePolicyInfoPageInfoAction {
  type: typeof SERVICE_QUERY_POLICY_MODIFY__SAVE_POLICY_INFO_PAGE_DATA;
  payload: {
    data: PolicyInfoFormValues;
  };
}

export interface SendOTPAction {
  type: typeof SERVICE_QUERY_POLICY_MODIFY__SEND_OTP;
  payload: {
    args: AaOtpSendcodeReq;
  };
}

export interface SendOTPDoneAction {
  type: typeof SERVICE_QUERY_POLICY_MODIFY__SEND_OTP_DONE;
  payload: {
    response: AaOtpSendcodeResp;
  };
}

export interface ResendOTPAction {
  type: typeof SERVICE_QUERY_POLICY_MODIFY__RESEND_OTP;
  payload: {
    args: AaOtpSendcodeReq;
  };
}

export interface ResendOTPDoneAction {
  type: typeof SERVICE_QUERY_POLICY_MODIFY__RESEND_OTP_DONE;
  payload: {
    response: AaOtpSendcodeResp;
  };
}

export interface AuthOTPAction {
  type: typeof SERVICE_QUERY_POLICY_MODIFY__AUTH_OTP;
  payload: {
    authOTPArgs: AaOtpVerifyReq;
    modifyPolicyPeriodArgs: PolicyAmendTravelperiodReq;
  };
}

export interface ExecuteCreditCardPaymentAction {
  type: typeof SERVICE_QUERY_POLICY_MODIFY__EXECUTE_CREDIT_CARD_PAYMENT;
  payload: {
    args: PaymentCreditAuthReq;
    modifyPolicyPeriodArgs: PolicyAmendTravelperiodReq;
  };
}

export interface ModifyPolicyPeriodAction {
  type: typeof SERVICE_QUERY_POLICY_MODIFY__MODIFY_POLICY_PERIOD;
  payload: {
    args: PolicyAmendTravelperiodReq;
  };
}

export interface UpdateCacheAction {
  type: typeof SERVICE_QUERY_POLICY_MODIFY__UPDATE_CACHE;
  payload: {
    cache: ModifyState;
  };
}

export interface ResetCacheAction {
  type: typeof SERVICE_QUERY_POLICY_MODIFY__RESET_CACHE;
}

export interface SaveModifyAction {
  type: typeof SERVICE_QUERY_POLICY_MODIFY__SAVE_MODIFY_REQ;
  payload: {
    args: PolicyAmendTravelperiodReq;
  };
}

export interface SaveTransIdAction {
  type: typeof SERVICE_QUERY_POLICY_MODIFY__SAVE_TRANS_ID;
  payload: {
    transId: string;
  };
}

export type ModifyActions =
    FetchPolicyDetailAction
  | FetchPolicyDetailDoneAction
  | SetAccessibleStepAction
  | SavePolicyInfoPageInfoAction
  | SendOTPAction
  | SendOTPDoneAction
  | ResendOTPAction
  | ResendOTPDoneAction
  | AuthOTPAction
  | ExecuteCreditCardPaymentAction
  | ModifyPolicyPeriodAction
  | UpdateCacheAction
  | ResetCacheAction
  | SaveModifyAction
  | SaveTransIdAction;
// ::: End
